import { Home, TrendingUp, Gift } from 'lucide-react';

const TEMPLATES = [
  {
    id: 'home_sales_purchases',
    title: 'Home sales & purchases',
    description:
      'Households buying or selling primary or secondary homes—ideal for mortgage payoffs, relocation cash-flow, and stepped-up basis planning.',
    category: 'Wealth events',
    gradient: ['#0ea5e9', '#6366f1'],
    icon: Home,
    comingSoon: true,
    previewColumns: ['Household', 'Signal', 'Metro', 'Timing'],
    previewRows: [
      ['Patel trust', 'Closed sale', 'Austin, TX', 'Q1'],
      ['Nguyen LLC', 'Under contract', 'Seattle, WA', '30d'],
      ['Brennan prop', 'Purchase', 'Denver, CO', 'Closing'],
      ['Okonkwo fam', 'Relist / price cut', 'Chicago, IL', 'Open'],
    ],
  },
  {
    id: 'liquidity_events',
    title: 'Liquidity events',
    description:
      'Founders and executives with real liquidity—exits, secondary sales, IPO lockups rolling off, earn-outs, and large deferred comp payouts.',
    category: 'Wealth events',
    gradient: ['#059669', '#14b8a6'],
    icon: TrendingUp,
    comingSoon: true,
    previewColumns: ['Contact', 'Event', 'Est. liquidity', 'Window'],
    previewRows: [
      ['M. Santos', 'Company sale', '$4.2M', '90d'],
      ['R. Ibrahim', 'Secondary shares', '$1.8M', 'Tender'],
      ['K. Volkov', 'IPO lockup release', '$6.5M', 'Q3'],
      ['J. Park', 'Earn-out paid', '$920K', 'Paid'],
    ],
  },
  {
    id: 'inheritances',
    title: 'Inheritances',
    description:
      'Beneficiaries settling estates and receiving bequests—timely for trust administration, IRA rules, tax elections, and wealth-transfer follow-up.',
    category: 'Wealth events',
    gradient: ['#a78bfa', '#e879f9'],
    icon: Gift,
    comingSoon: true,
    previewColumns: ['Beneficiary', 'Vehicle', 'Stage', 'Advisor note'],
    previewRows: [
      ['E. Whitaker', 'Revocable trust', 'Distribution', 'IRA mix'],
      ['Chen heirs', 'Probate estate', 'Inventory', 'RMD plan'],
      ['Martinez fam', 'ILIT distribution', 'Scheduled', 'Crummey'],
      ['O. Diallo', 'Inherited IRA', 'Titling review', '10-yr rule'],
    ],
  },
];

export default TEMPLATES;
